import React, { Component, Suspense } from "react";
import { replacestate } from "./../../../redux_store/actions/index";
import store from "./../../../redux_store/store/index";
import { withTranslation } from "react-multi-lang";
import "rc-tabs/assets/index.css";
import { AtTabs } from "./../../../controls/custom-tabs.styles";
import Tabs, { TabPane } from "rc-tabs";
import { NavLink, Redirect } from "react-router-dom";
import {
  defalutreduxState,
  isMultitenant,
} from "./../../../custom_functions/Constance.jsx";
import $ from "jquery";
import "bootstrap";
import { withAlert } from "react-alert";
import {
  ControlRights,
  getModuleRihtsOnOrderModule,
  ModuleRights,
  Servicecallforuserrightscallback,
  SubMenuRightsonScreenViews,
  updateActiveUserTime,

} from "../../../custom_functions/Functions";

const createHistory = React.lazy(() => import("./../../general/History.jsx"));
const Menu = React.lazy(() => import("./../../Menu.jsx"));
const Protocols = React.lazy(() => import("./../../Protocols.jsx"));
const ApplicationHeader = React.lazy(() =>
  import("./../../general/ApplicationHeader.jsx")
);
const ApplicationFooter = React.lazy(() =>
  import("./../../general/ApplicationFooter.jsx")
);

class PProtocols extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    let notificationorder = "";
    let isnotificationprocess = false;
    let isnotificationprotocolprocess = false;
    let notificationprotocolname = "";
    let notificationprotocol = "";
    let notificationpreviouspath = "";
    if (
      props.location !== undefined &&
      props.location !== null &&
      props.location.state !== undefined &&
      props.location.state !== null
    ) {
      let notifiystate = props.location.state;

      notificationorder =
        notifiystate.ordercode !== undefined ? notifiystate.ordercode : "";
      isnotificationprocess = notifiystate.isprocess
        ? notifiystate.isprocess
        : false;

      isnotificationprotocolprocess = notifiystate.isprotocolprocess
        ? notifiystate.isprotocolprocess
        : false;
      notificationprotocolname =
        notifiystate.protocolmastername !== undefined
          ? notifiystate.protocolmastername
          : "";
      notificationprotocol = notifiystate;
      notificationpreviouspath = notifiystate.perviouspath;

      setTimeout(() => {
        this.props.history.push("/protocols");
      }, 100);
    }

    this.state = {
      validurl: true,
      MenuGroup: "SheetCreation",
      ChildMenu: "SheetViewcss",
      PageName: this.props.t("Templates.Protocoltemplates.IDS_LBL_PROTOCOLTEMPLTES", { param: "" }),
      menuoption: 0,
      open: false,
      Menuselected: "",
      modalopen: false,
      ordercode: undefined,
      userrightdetails: undefined,
      notificationorderno: notificationorder,
      isnotificationprocess: isnotificationprocess,
      isnotificationprotocolprocess: isnotificationprotocolprocess,
      notificationprotocolname: notificationprotocolname,
      sheetcreationvisible: false,
      Sheetmapvisible: false,
      notificationprotocol: notificationprotocol,
      isorderreload: false,
      isorderortemplate: "",
      screenname: "Protocol",
      notificationpreviouspath: notificationpreviouspath
    };

    this.MainMeunClick = this.MainMeunClick.bind(this);
    this.ELNurl = window.appUrl.ELN;

    // if (this.state.isnotificationprotocolprocess === true) {
    //   this.Protocols = (
    //     <Protocols
    //       documentInfo={this.state.documentInfo}
    //       rights={this.state.userrightdetails}
    //       notificationorder={this.state.notificationorderno}
    //       isnotificationprocess={this.state.isnotificationprotocolprocess}
    //     />
    //   );
    // }

  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  setScreenView() {
    updateActiveUserTime();

    this.setState({
      validurl: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE")
    })
  }

  componentDidMount() {
    updateActiveUserTime();

    if (!store.getState().Menu?.Controlrights?.rights) {
      Servicecallforuserrightscallback("" + this.ELNurl + "/User/GetUserRightsonUser",
        {
          usercode: sessionStorage.User,
          lsusergroup: { usergroupcode: sessionStorage.multiusergroups },
        },
        () => this.setScreenView()
      );
    } else {
      this.setScreenView();
    }

    if (
      this.props.location.hash !== undefined &&
      this.props.location.hash.length > 0
    ) {
      let Sheetrun = this.props.location.hash.substring(
        2,
        this.props.location.hash.length - 1
      );
      if (
        Sheetrun !== undefined &&
        Sheetrun.split(":").length > 1 &&
        Sheetrun.split(":")[0] === "orderid"
      ) {
        let ordercode = Sheetrun.split(":")[1];
        this.setState({
          MenuGroup: "SheetView",
          PageName: this.props.t("menu.IDS_REGORDEREXE", {
            param: "",
          }),
          Menuselected: "SheetView_menu_group",
          ordercode: ordercode,
        });
      }
    }

    this.setState({ activekey: 1 });
  }
  updateglobalsearch(responce, isorderortemplate) {
    this.setState({
      isorderreload: responce ? responce : false,
      isorderortemplate: isorderortemplate,
    });
  }
  //add
  ontabclick = (key) => { };

  MainMeunClick(Menu) {
    let PageName = "";
    let open = false;
    if (Menu === "SheetCreation") {
      PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETTEMPLATE", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetView") {
      PageName = this.props.t("menu.IDS_REGORDEREXE", {
        param: "",
      });
      open = false;
    } else if (Menu === "SheetSetting") {
      PageName = this.props.t("menu.IDS_SHEETSETTING", {
        param: "",
      });
    } else if (Menu === "AuditTrail") {
      PageName = this.props.t("Audittrail.Audittrailhistory.IDS_LBL_AUDITTRAIL", {
        param: "",
      });
      open = false;
    } else if (Menu === "UserManagement") {
      PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
        param: "",
      });
      open = false;
    } else if (Menu === "Dashboard") {
      PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
        param: "",
      });
      open = false;
    } else if (Menu === "Masters") {
      PageName = this.props.t("Masters.ID_MASTERS", {
        param: "",
      });
      open = false;
    } else if (Menu === "DownloadReport") {
      PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
        param: "",
      });
      open = false;
    }

    this.setState({
      MenuGroup: Menu,
      PageName: PageName,
      open: open || true,
      Menuselected: "",
    });
  }

  ChilMenuclick(Menu) {
    this.setState({ ChildMenu: Menu });
  }

  idle_save() {
    this.setState({ idle_save: true })
  }

  onlogoutSuccess(response) {
    store.dispatch(replacestate(defalutreduxState));
    setTimeout(() => {
      let tenantdomain = $.session.get("tenantdomain");

      if (tenantdomain !== undefined) {
        isMultitenant === 0
          ? this.props.history.push("/")
          : this.props.history.push("/#" + tenantdomain);
        this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
      } else {
        this.props.history.push("/")
      }
    }, 100);
  }

  onlogoutFailure(response) { }

  onredirectrights(objrights) {
    // this.setState({
    //     userrightdetails: objrights, sheetcreationvisible: objrights.Sheetcreation,
    //     Protocolcreationvisible: objrights.Protocols, Sheetmapvisible: objrights.Sheetsetting
    // });
    let proRights = ControlRights("IDS_MDL_TEMPLATES", "IDS_SCN_PROTOCOLTEMPLATE");
    let tempMapRights = ControlRights("IDS_MDL_TEMPLATES");

    this.setState({
      userrightdetails: objrights,
      sheetcreationvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_SHEETTEMPLATE"),
      Protocolcreationvisible: proRights.UserGroupRights.rights,
      Sheetmapvisible: tempMapRights,
      tempmapvisible: SubMenuRightsonScreenViews("IDS_MDL_TEMPLATES", "IDS_SCN_TEMPLATEMAPPING"),
    });
  }

  OnNotificationchange(data) {
    if (data !== null && data !== undefined) {
      // let notificationorder =
      //   data.ordercode !== undefined ? data.ordercode : "";
      // let isnotificationprocess = data.isprocess ? data.isprocess : false;

      this.setState({
        notificationprotocol: data,
        // notificationorderno: notificationorder,
        // isnotificationprocess: isnotificationprocess,
        // isnotificationprotocolprocess: isnotificationprocess,
        isnotificationprotocolprocess: true
      });
    }
  }

  onresetnotification() {
    if (
      this.props.location !== undefined &&
      this.props.location !== null &&
      this.props.location.state !== undefined &&
      this.props.location.state !== null
    ) {
      const history = createHistory;
      if (history.location !== undefined) {
        if (history.location.state && history.location.state.ordercode) {
          let state = { ...history.location.state };
          delete state.ordercode;
          history.replace({ ...history.location, state });
        }
      }
    }

    this.setState({
      notificationprotocol: undefined,
      isnotificationprocess: false,
      isnotificationprotocolprocess: false,
    });
  }

  redirecttohome() {
    this.props.history.push("/Home");
  }

  render() {
    if (!$.session.get("User")) {
      setTimeout(() => {
        let tenantdomain = $.session.get("tenantdomain");
        if (this.props && this.props.history) {
          if (tenantdomain !== undefined) {
            isMultitenant === 0
              ? this.props.history.push("/")
              : this.props.history.push("/#" + tenantdomain);
            // this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
          } else {
            this.props.history.push("/")
          }
        }
      }, 100);
      return <div></div>;
    }

    if (!this.state.validurl) {
      const getPath = getModuleRihtsOnOrderModule("IDS_MDL_SETUP");
      console.log(getPath);

      let path = getPath?.path !== undefined ? getPath?.path : "/Home";

      return <Redirect to={path} />;
    }

    return (
      <div id="idElnBody">
        <Suspense fallback={<div></div>}>
          <Menu
            sendData={this.MainMeunClick}
            childmenuclick={this.ChilMenuclick.bind(this)}
            selected={this.state.Menuselected}
            menugroup={this.state.MenuGroup}
            screenname={this.state.screenname}
            redirectrights={this.onredirectrights.bind(this)}
          />
        </Suspense>
        <div
          id="bodycontent"
          className="d-flex flex-column protocolTempContainer"
        >
          <Suspense fallback={<div></div>}>
            {/* <div id="onremoveitems"> */}
            <ApplicationHeader
              onlogoutSuccess={this.onlogoutSuccess.bind(this)}
              redirecttohome={this.redirecttohome.bind(this)}
              onlogoutFailure={this.onlogoutFailure.bind(this)}
              PageName={this.state.PageName}
              OnNotificationchange={this.OnNotificationchange.bind(this)}
            // updategloabalsearch={this.updateglobalsearch.bind(this)} isorderreload={this.state.isorderreload} isorderortemplate={this.state.isorderortemplate}
            />
            {/* </div> */}
          </Suspense>
          <AtTabs>
            <Tabs activeKey={"2"} onTabClick={this.ontabclick} moreIcon="...">
              {this.state.sheetcreationvisible ? (
                <TabPane
                  tab={
                    <NavLink
                      to={{ pathname: "/sheetcreation" }}
                      title={this.props.t("Orders.Sheetorders.IDS_LBL_SHEET", {
                        param: "",
                      })}
                    >
                      {this.props.t("Orders.Sheetorders.IDS_LBL_SHEET", {
                        param: "",
                      })}
                    </NavLink>
                  }
                  key="1"
                ></TabPane>
              ) : (
                ""
              )}
              {this.state.Protocolcreationvisible ? (
                <TabPane
                  tab={this.props.t("Orders.Protocolorders.IDS_LBL_PROTOCOL", { param: "" })}
                  key="2"
                >
                  <Suspense fallback={<div></div>}>
                    <Protocols
                      notificationprotocol={this.state.notificationprotocol}
                      documentInfo={this.state.documentInfo}
                      rights={this.state.userrightdetails}
                      // notificationorder={this.state.notificationorderno}
                      isnotificationprocess={
                        this.state.isnotificationprotocolprocess
                      }
                      notificationprotocolname={
                        this.state.notificationprotocolname
                      }
                      onresetnotification={this.onresetnotification.bind(this)}
                      notificationpreviouspath={this.state.notificationpreviouspath}
                      // updategloabalsearch={this.updateglobalsearch.bind(this)}
                      idle_save={this.state.idle_save}
                    />
                  </Suspense>
                </TabPane>
              ) : (
                ""
              )}
              {this.state.tempmapvisible ? (
                <TabPane
                  tab={
                    <NavLink
                      to={{ pathname: "/sheetmapping" }}
                      title={this.props.t("Templates.Templatemapping.IDS_LBL_ELNTEMPLATES", {
                        param: "",
                      })}
                    >
                      {this.props.t("Templates.Templatemapping.IDS_LBL_ELNTEMPLATES", {
                        param: "",
                      })}
                    </NavLink>
                  }
                  key="3"
                ></TabPane>
              ) : (
                ""
              )}
            </Tabs>
          </AtTabs>
        </div>
        <Suspense fallback={<div></div>}>
          <ApplicationFooter
            onlogoutSuccess={this.onlogoutSuccess.bind(this)}
            onlogoutFailure={this.onlogoutFailure.bind(this)}
            onforgot={this.props.onforgot}
            idle_save={this.idle_save.bind(this)}
          />
        </Suspense>
      </div>
    );
  }
}
export default withAlert()(withTranslation(PProtocols));
